var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 37,
    viewBox: "0 0 15 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80306 36.7206C7.19913 37.1055 7.83223 37.0964 8.21713 36.7004L14.4896 30.2461C14.8745 29.8501 14.8654 29.217 14.4694 28.8321C14.0733 28.4472 13.4402 28.4562 13.0553 28.8523L7.4798 34.5893L1.74273 29.0139C1.34667 28.629 0.713565 28.638 0.328658 29.0341C-0.0562485 29.4301 -0.0472051 30.0632 0.348857 30.4481L6.80306 36.7206ZM6.0001 1.01428L6.5001 36.0177L8.4999 35.9891L7.9999 0.985717L6.0001 1.01428Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.0d12c9247327a6581fb0099ad92beb2d.svg";
export { ForwardRef as ReactComponent };